import { Reveal, Tag, Heading } from "./Reveal";

const CHAPTERS = [
  { num: "01", title: "The craftsmanship", text: "How a door closes. How a line of tile meets a wall. The work itself has to be right — not close enough, right." },
  { num: "02", title: "The design & the details", text: "A finished space should feel finished. The eighth-of-an-inch things you'll never consciously notice are the things we obsess over." },
  { num: "03", title: "The budget & the timeline", text: "A number you can plan around. A schedule you can trust. No drift, no surprise add-ons, no vanishing acts." },
  { num: "04", title: "The people living here", text: "You're eating breakfast in this house while we work. That reality shapes how we show up, every single day." },
];

export const Manifesto = () => (
  <section id="difference" className="py-24 lg:py-40 bg-sand" data-testid="difference-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Tag>The Construction Alliance difference</Tag>
            <Heading className="mt-6">Good work starts with giving a damn.</Heading>
            <p className="mt-8 text-base sm:text-lg text-ink/70 leading-relaxed max-w-md">
              We're building more than cabinets, bathrooms and floors. We're changing the space you live your life in.
            </p>
            <p className="mt-4 font-display font-medium text-2xl tracking-[-0.015em] text-ink">We take that seriously.</p>
          </div>
        </Reveal>
        <div className="lg:col-span-7 border-t border-ink/15">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.06}>
              <div className="group grid grid-cols-12 gap-4 items-start border-b border-ink/15 py-10" data-testid={`manifesto-chapter-${c.num}`}>
                <span className="col-span-3 sm:col-span-2 font-display font-semibold text-4xl sm:text-6xl tracking-[-0.03em] text-ink/15 group-hover:text-teal transition-colors duration-500 leading-none">{c.num}</span>
                <div className="col-span-9 sm:col-span-10">
                  <h3 className="font-display font-medium text-2xl sm:text-4xl tracking-[-0.015em] text-ink">{c.title}</h3>
                  <p className="mt-4 text-base sm:text-lg text-ink/65 leading-relaxed max-w-xl">{c.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
